import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useAuthStore = defineStore("auth", () => {
  const role = ref("");
  const firstName = ref("");
  const lastName = ref("");
  const username = ref("");
  const isAdmin = computed(() => role.value === "ADMIN");
  const isCompanyAdmin = computed(() => role.value === "COMPANY_ADMIN");
  const fullName = computed(
    () =>
      [firstName.value, lastName.value].filter(Boolean).join(" ") ||
      username.value
  );

  return {
    role,
    firstName,
    lastName,
    username,
    fullName,
    isAdmin,
    isCompanyAdmin,
  };
});
